var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file Progress type="circle"
 * @author zhuwanying02
 */
import React, { PureComponent } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { classPrefix } from '../../common/util';

// size         可选，'large'，'small'
// status       可选，'normal'，'success'，'error'
// percent      必填，取值在0-100之间，大于100时取100，小于0时取0
// formatText   可自定义text内容，默认显示百分比
// className    可选，在根元素上添加类
// style        可选，在根元素上添加样式
// classPrefix  可选，类前缀

var CircleProgress = function (_PureComponent) {
    _inherits(CircleProgress, _PureComponent);

    function CircleProgress(props) {
        _classCallCheck(this, CircleProgress);

        // 圆环半径(与path元素的d属性中取值同步)
        var _this = _possibleConstructorReturn(this, (CircleProgress.__proto__ || Object.getPrototypeOf(CircleProgress)).call(this, props));

        _this.RADIUS = 47;
        // 圆环周长
        _this.PERIMETER = 2 * Math.PI * _this.RADIUS;
        _this.BASE_STROKEWIDTH = '4';
        return _this;
    }

    _createClass(CircleProgress, [{
        key: 'render',
        value: function render() {
            var _classnames, _classnames2, _classnames3, _classnames4;

            var _props = this.props,
                classPrefix = _props.classPrefix,
                className = _props.className,
                style = _props.style,
                size = _props.size,
                status = _props.status,
                percent = _props.percent,
                formatText = _props.formatText;

            var validatedPercent = percent > 100 ? 100 : percent < 0 ? 0 : percent;
            // 当百分比为100%时，自动将状态值设置为sucess
            var skin = validatedPercent === 100 ? 'success' : status;
            var prefixCls = classPrefix + '-circle-progress';
            var rootClass = classnames((_classnames = {}, _defineProperty(_classnames, prefixCls, true), _defineProperty(_classnames, prefixCls + '-' + size, true), _defineProperty(_classnames, className, !!className), _classnames));
            var pathClass = classnames((_classnames2 = {}, _defineProperty(_classnames2, prefixCls + '-path', true), _defineProperty(_classnames2, prefixCls + '-path-' + skin, true), _classnames2));
            var textClass = classnames((_classnames3 = {}, _defineProperty(_classnames3, prefixCls + '-text', true), _defineProperty(_classnames3, prefixCls + '-text-' + size, true), _classnames3));
            var iconClass = classnames((_classnames4 = {
                'circle-icon': true
            }, _defineProperty(_classnames4, 'circle-icon-' + size, true), _defineProperty(_classnames4, 'circle-icon-' + skin, true), _classnames4));
            var pathStrokeWidth = validatedPercent === 0 ? '0' : this.BASE_STROKEWIDTH;
            // 百分比系数
            var co = validatedPercent * 1.0 / 100;
            // 计算strokeDasharray="length, percentage"属性
            var length = co * this.PERIMETER;
            var percentage = this.PERIMETER;
            // 格式化显示text
            var text = validatedPercent + '%';
            if (formatText) {
                text = formatText(validatedPercent);
            }
            return React.createElement(
                'div',
                { className: rootClass, style: style },
                React.createElement(
                    'svg',
                    { className: prefixCls + '-box', viewBox: '0 0 100 100' },
                    React.createElement('path', { className: prefixCls + '-trail',
                        d: 'M 50,50 m 0,-47 a 47,47 0 1 1 0,94 a 47,47 0 1 1 0,-94',
                        strokeWidth: this.BASE_STROKEWIDTH,
                        fillOpacity: '0',
                        strokeDasharray: percentage + 'px, ' + percentage + 'px'
                    }),
                    React.createElement('path', { className: pathClass,
                        d: 'M 50,50 m 0,-47 a 47,47 0 1 1 0,94 a 47,47 0 1 1 0,-94',
                        strokeLinecap: 'round',
                        strokeWidth: pathStrokeWidth,
                        fillOpacity: '0',
                        strokeDasharray: length + 'px, ' + percentage + 'px'
                    })
                ),
                React.createElement(
                    'span',
                    { className: textClass },
                    validatedPercent === 100 || skin === 'error' ? React.createElement('i', { className: iconClass }) : text
                )
            );
        }
    }]);

    return CircleProgress;
}(PureComponent);

CircleProgress.defaultProps = {
    classPrefix: classPrefix,
    status: 'normal',
    percent: 0,
    size: 'large'
};
CircleProgress.propTypes = {
    className: PropTypes.string,
    classPrefix: PropTypes.string,
    style: PropTypes.object,
    size: PropTypes.oneOf(['large', 'small']),
    status: PropTypes.oneOf(['normal', 'success', 'error']),
    percent: PropTypes.number,
    formatText: PropTypes.func
};
export default CircleProgress;